import { render } from "./LocaleSwitcher.vue?vue&type=template&id=7371621f"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"
script.render = render

export default script